import { Component, OnInit, ViewChild, TemplateRef, inject } from '@angular/core';
import { Organo } from '../servicio/servicio.service';
import { AppModule } from '../../app-module';
import { AuthService } from '../../commons/services/auth.service';
import { AlertService } from '../../commons/components/alert/alert.service';
import { AlertComponent } from '../../commons/components/alert/alert.component';
import { BajaDiaInhabilcommand, DiasInhabilesDTO, Estado, GetDiasInhabilesFiltradosQuery, RegDiaInhabilcommand, RequestInsertDiaInhabil, UpdDiaInhabilcommand } from '../../commons/class/diaInhabil.class';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigDiaInhabilService } from './configDiaInhabil.service';
import { ConfirmationDialogService } from '../../commons/components/confirm-dialog/confirm-dialog.service';
import { v4 as uuidv4 } from 'uuid';
import { ModalIframeService } from '../../commons/components/modal-iframe/modal-iframe.service';
import { Documents } from '../../commons/class/archivo.inteface';
import { ElectronicDemandService } from '../demanda/electronicDemand.service';
import { LoaderComponent } from '../../commons/components/loader/loader.component';
import { ListaArchivosComponent } from '../../commons/components/downLoadFile/lista-archivos/lista-archivos.component';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ENV_TOKEN } from '../../app-module.token';

@Component({
    selector: 'oaj-config-dia-inhabil',
    templateUrl: './configDiaInhabil.component.html',
    styleUrls: ['./configDiaInhabil.component.css'],
    imports: [AppModule, AlertComponent, LoaderComponent, ListaArchivosComponent],
    providers: [AuthService, AlertService, ConfigDiaInhabilService, ConfirmationDialogService, ModalIframeService]
})
export class ConfigDiaInhabilComponent implements OnInit {
    TipoOrganismo = '';
    organos: Organo[] = [];
    selectedOrganismoId: number | null = null;
    loading = false;
    organosLoading = false;
    organosError = '';
    errorMessage = '';
    successMessage = '';
    InsertEntity: RequestInsertDiaInhabil = new RequestInsertDiaInhabil;
    submittedReg = false;
    DaysLst!: DiasInhabilesDTO[];
    isOrganismoAdmin = false;
    private constService: any;
    uuid = "0";
    public lstDocumentos: any[] = [];
    isLoadingFile = false;
    sMensajeLoad = "Consultando archivos...";
    archivosModal: Documents[] = [];
    archivosModalLoading = false;
    archivosModalError = '';
    @ViewChild('modalArchivos') modalArchivosTpl?: TemplateRef<any>;
    @ViewChild('registro') registroTemplate!: TemplateRef<any>;
    Estado = Estado;
    Edicion = false;
    bSuperAdmin = false;
    idConfiguracionEditar = 0;
    estados = Object.keys(Estado).filter(k => isNaN(Number(k))).map(k => ({ key: k, value: Estado[k as keyof typeof Estado] }));
    formFiltro!: FormGroup;
    hoy = new Date();

    private authService: AuthService = inject(AuthService);
    private modalService: NgbModal = inject(NgbModal);
    private Service: ConfigDiaInhabilService = inject(ConfigDiaInhabilService);
    private alertService: AlertService = inject(AlertService);
    private modalConfirmacionService: ConfirmationDialogService = inject(ConfirmationDialogService);
    private modalIframeService: ModalIframeService = inject(ModalIframeService);
    private _service: ElectronicDemandService = inject(ElectronicDemandService);
    private router: Router = inject(Router);
    private fb: FormBuilder = inject(FormBuilder);
    readonly environment = inject(ENV_TOKEN);

    constructor() {
        this.constService = this.environment;
        this.formFiltro = this.fb.group({
            estado: [''],
            fechaInicio: [this.hoy.toISOString().split('T')[0]],
            fechaFin: [this.hoy.toISOString().split('T')[0]]
        });
    }

    ngOnInit(): void {
        this.isOrganismoAdmin = this.authService.getIsAdmin();
        this.bSuperAdmin = this.authService.getbSuperAdmin();
        this.TipoOrganismo = this.authService.getNombreTipoOrganismo();
        this.cargarOrganos();
        this.ConsultaDiasActivos();
        this.idConfiguracionEditar = 0;
        this.Edicion = false;
    }

    /**
     * Funcion para manejar el envio del formulario de filtro, se valida que se hayan llenado todos los campos requeridos, que la fecha inicio sea menor o igual a la fecha fin, se hace una consulta al servicio para obtener los dias inhabiles filtrados dependiendo de los criterios seleccionados, se muestra un mensaje de error si no se cumplen las validaciones o si ocurre un error durante la consulta de los dias inhabiles filtrados
     * @returns 
     */
    onSubmitFiltro() {
        const { estado, fechaInicio, fechaFin } = this.formFiltro.value;
        if (!estado) {
            this.alertService.warn("Favor de seleccionar un estado", { autoClose: true, keepAfterRouteChange: false }); return;
        }
        if (!fechaInicio) {
            this.alertService.warn("Favor de ingresar la fecha inicio del registro", { autoClose: true, keepAfterRouteChange: false }); return;
        }
        if (!fechaFin) {
            this.alertService.warn("Favor de ingresar la fecha fin del registro", { autoClose: true, keepAfterRouteChange: false }); return;
        }

        const inicio = new Date(fechaInicio);
        const fin = new Date(fechaFin);

        if (inicio > fin) {
            this.alertService.warn("La fecha inicio debe ser menor o igual a la fecha fin", { autoClose: true, keepAfterRouteChange: false }); return;
        }

        const request = new GetDiasInhabilesFiltradosQuery();
        request.Estado = estado;
        request.FechaInicio = fechaInicio;
        request.FechaFin = fechaFin;

        this.loading = true;

        const idTypeCourt = this.authService.getTipoOrganismo();
        request.TipoOrganismoIdIOJ = idTypeCourt;

        this.Service.getDiasInhabilesFiltrados(request).subscribe({
            next: (response: any) => {

                if (response.succcess) {
                    this.DaysLst = response.data;
                    //console.log('DaysLst:', this.DaysLst);
                }
                else {
                    this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                }
                this.loading = false;
            },
            error: (error) => {
                this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                //  console.log('error consulta dias Inhabiles por filtro:', error.message);
                this.loading = false;
            }
        });



        // console.log("Filtro aplicado:", this.formFiltro.value);
    }

    /**
     * Funcion para cargar el catalogo de organos dependiendo del tipo de organismo del usuario, se hace una consulta al servicio para obtener los organos dependiendo del tipo de organismo, se muestra un mensaje de error si ocurre un error durante la consulta de los organos
     */
    private cargarOrganos(): void {

        const idTypeCourt = this.authService.getTipoOrganismo();
        const idOrgAux = this.authService.getIdOrganoAux();


        this.authService.getOrganosOIJ(idTypeCourt, idOrgAux).subscribe({
            next: (response: any) => {

                if (response.succcess) {
                    this.organos = response.data ?? [];
                    this.organosLoading = false;
                }
            },
            error: (error) => {
                console.error(JSON.stringify(error));
                this.organosError = 'No fue posible cargar el catalogo de organos.';
                this.organosLoading = false;
            }
        });
    }

    /**
     * funcion para abrir la modal de registro de dia inhábil, se valida que se haya seleccionado un organo para agregar la configuración, se muestra una modal con el formulario de registro, se muestra un mensaje de error si no se ha seleccionado un organo o si ocurre un error al abrir la modal
     * @param registro 
     * @returns 
     */
    agregarConfiguracion(registro: any): void {
        this.Edicion = false;
        //this.InsertEntity = new RequestInsertDiaInhabil; 
        this.errorMessage = '';
        //this.uuid = "0";
        this.idConfiguracionEditar = 0;
        //this.lstDocumentos = [];

        if (this.selectedOrganismoId === null || this.selectedOrganismoId === undefined) {
            this.errorMessage = 'Selecciona un organo del catalogo para agregar configuración.';
            return;
        }

        this.modalService.open(registro, { ariaLabelledBy: 'modal-basic-title' }).result.then(
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (result) => {
                this.submittedReg = false;
            },
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            (reason) => {
                this.submittedReg = false;
            }

        );



    }

    /**
     * Funcion para abrir la modal de edicion de dia inhábil, se valida que se haya seleccionado un organo para editar la configuración, se muestra una modal con el formulario de edicion y los datos cargados, se muestra un mensaje de error si no se ha seleccionado un organo o si ocurre un error al abrir la modal o durante la consulta de los datos del dia inhábil a editar
     * @param day 
     */
    editarConfiguracion(day: DiasInhabilesDTO): void {
        this.Edicion = true;
        this.errorMessage = '';
        this.InsertEntity = new RequestInsertDiaInhabil;
        this.InsertEntity.motivo = day.motivo;
        this.InsertEntity.fechaInicioStruct = day.fechaIncio.substring(0, 16);
        this.InsertEntity.fechaFinStruct = day.fechaFin.substring(0, 16);
        this.idConfiguracionEditar = day.idConfigDiasInhabiles;
        this.uuid = day.guidRel;

        this.GetDocumentosPantallaEditar(day.idConfigDiasInhabiles).then((docs) => {
            this.lstDocumentos = docs;

            this.modalService.open(this.registroTemplate, { ariaLabelledBy: 'modal-basic-title' }).result.then(
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                (result) => {
                    //  console.log(result);
                    this.submittedReg = false;
                },
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                (reason) => {
                    //  console.log(reason);
                    this.submittedReg = false;
                }
            );
        });
    }

    /**
     * Funcion para obtener los documentos relacionados a la configuracion del dia inhábil, se hace una consulta al servicio para obtener los documentos dependiendo del id de la configuración, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
     * @param idConfiguracion 
     * @returns Documents[]
     */
    public GetDocumentosPantallaEditar(idConfiguracion: number): Promise<Documents[]> {

        return new Promise((resolve) => {
            this.isLoadingFile = true;
            this.Service.obtenerDocumentoRegistroDiaInhabil(idConfiguracion)
                .subscribe((response: Documents[]) => {
                    if (response?.length > 0) {
                        this.isLoadingFile = false;

                        resolve(response);
                    }
                    else {
                        this.isLoadingFile = false;
                        resolve([]);
                    }
                }, (error: any) => {
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                    this.isLoadingFile = false;
                    resolve([]);
                });

        });
    }

    /**
     * Funcion para cargar los dias inhabiles activos, se hace una consulta al servicio para obtener los dias inhabiles activos dependiendo del tipo de organismo del usuario, se muestra un mensaje de error si ocurre un error durante la consulta de los dias inhabiles activos
     */
    ConsultaDiasActivos(): void {
        this.loading = true;

        const idTypeCourt = this.authService.getTipoOrganismo();

        this.Service.getDiasInhabilesActivos(idTypeCourt).subscribe({
            next: (response: any) => {

                if (response.succcess) {
                    this.DaysLst = response.data;
                    //  console.log('DaysLst:', this.DaysLst);
                }
                else {
                    this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                }
                this.loading = false;
            },
            error: (error) => {
                this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                //  console.log('error consulta dias Inhabiles:', error.message);
                this.loading = false;
            }
        });

    }

    /**
     * Funcion para inactivar un dia inhábil, se muestra una modal de confirmacion antes de inactivar la configuración, se hace una consulta al servicio para inactivar el dia inhábil dependiendo del id de la configuración, se muestra un mensaje de error si ocurre un error durante la inactivacion del dia inhábil o durante la consulta de los dias inhabiles activos despues de la inactivacion
     * @param idDiaInhabil 
     */
    InactivarDiaInhabil(idDiaInhabil: number): void {

        this.modalConfirmacionService.confirm('Confirmación',
            'Va dar de baja la configuración ¿desea continuar?',
            'Aceptar',
            'Cancelar',
            'sm').then((confirmed) => {
                if (confirmed) {

                    const request: BajaDiaInhabilcommand = new BajaDiaInhabilcommand();
                    request.IdConfigDiasInhabiles = idDiaInhabil;
                    request.IOIJBaja = this.authService.getIdOrgan();
                    // console.log('Request a enviar:', request);
                    this.Service.DeleteDiaInhabil(request).subscribe({
                        next: (response: any) => {

                            if (response.succcess) {
                                this.alertService.success("Baja correcta de la configuración del día inhábil", { autoClose: true, keepAfterRouteChange: false });

                                this.ConsultaDiasActivos();
                            }
                            else {
                                this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                            }
                        },
                        error: (error) => {
                            this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                            console.error('error al eliminar día Inhábile:', error.message);
                        }
                    });

                }
            }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));



    }

    /**
     * Funcion para manejar el envio del formulario de registro, se valida que se hayan llenado todos los campos requeridos, se hace una consulta al servicio para crear o actualizar la configuración del dia inhábil dependiendo si se esta editando o creando una nueva configuración, se muestra un mensaje de error si no se cumplen las validaciones o si ocurre un error durante la consulta de creacion o actualizacion de la configuración del dia inhábil, despues de crear o actualizar la configuración se recarga la lista de dias inhabiles activos y se cierra la modal
     */
    onSubmitRegistro() {
        this.submittedReg = true;
        //  console.log('InsertEntity a enviar:', this.InsertEntity);
        // Validaciones
        if (!this.InsertEntity.motivo || this.InsertEntity.motivo.trim() === '') {
            this.alertService.warn("Favor de ingresar el motivo del registro", { autoClose: true, keepAfterRouteChange: false });
            return;
        }
        if (!this.InsertEntity.fechaInicioStruct) {
            this.alertService.warn("Favor de ingresar la fecha inicio del registro", { autoClose: true, keepAfterRouteChange: false });
            return;
        }
        if (!this.InsertEntity.fechaFinStruct) {
            this.alertService.warn("Favor de ingresar la fecha fin del registro", { autoClose: true, keepAfterRouteChange: false });
            return;
        }
        if (!this.lstDocumentos || this.lstDocumentos.length === 0) {
            this.alertService.warn("Favor de ingresar el documento del registro", { autoClose: true, keepAfterRouteChange: false });
            return;
        }

        const request: RegDiaInhabilcommand = new RegDiaInhabilcommand();
        request.IOIJ = this.selectedOrganismoId!;
        request.sMotivo = this.InsertEntity.motivo;
        request.fechaIncio = this.InsertEntity.fechaInicioStruct;
        request.fechaFin = this.InsertEntity.fechaFinStruct;
        request.TipoOrganismoIdIOJ = this.authService.getTipoOrganismo();
        request.OIJregistra = this.authService.getIdOrgan();
        request.guidRel = this.uuid;

        if (!this.Edicion) {
            this.Service.CreateDiaInhabil(request).subscribe({
                next: (response: any) => {

                    if (response.succcess) {
                        this.alertService.success("Se creo correctamente la configuración del dia", { autoClose: true, keepAfterRouteChange: false });

                        this.InsertEntity = new RequestInsertDiaInhabil;
                        this.uuid = "0";
                        this.lstDocumentos = [];

                        this.reloadCurrentRoute();
                        this.ConsultaDiasActivos();

                    }
                    else {
                        this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (error) => {
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                    console.error('error al insertar dias Inhabiles:', error.message);
                }
            });

        }
        else {

            const requestUpdate: UpdDiaInhabilcommand = { ...request, IdConfiguracionDiasInhabiles: this.idConfiguracionEditar }
            requestUpdate.IOIJ = 0;
            this.Service.UpdateDiaInhabil(requestUpdate).subscribe({
                next: (response: any) => {

                    if (response.succcess) {
                        this.alertService.success("Se actualizo correctamente la configuración del dia", { autoClose: true, keepAfterRouteChange: false });
                        this.reloadCurrentRoute();
                        this.ConsultaDiasActivos();
                    }
                    else {
                        this.alertService.error(response.message, { autoClose: true, keepAfterRouteChange: false });
                    }
                },
                error: (error) => {
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                    console.error('error al actualizar dias Inhabiles:', error.message);
                }
            });
        }

        this.submittedReg = false;

    }

    /**
     * Funcion para manejar el cambio de valor en el dropdown de organismo, se asigna el valor seleccionado al id del organismo seleccionado
     * @param ddlValue 
     */
    onChangeOrgano(ddlValue: any): void {
        this.selectedOrganismoId = Number(ddlValue);
    }

    /**
     * Funcion para cargar los documentos cargados en la pantalla, se hace una consulta al servicio para obtener los documentos dependiendo del guid generado para la transaccion, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
     */
    cargaArchivo(): void {

        const IdPantalla = 0;
        const TipoArchivo = this.constService.TipoDoctos.DiasInhabiles;

        if (this.uuid == "0") {
            this.uuid = uuidv4();
        }

        const urlFirma = `${this.constService.baseUrlFirma}?userName=${this.authService.getUserName()}&idUser=${this.authService.getIdUser()}&idOrganismo=${this.authService.getIdOrgan()}&IdSystem=1&IdPantalla=${IdPantalla}&IdTransaction=${this.uuid}&tipoArchivo=${TipoArchivo}&fo=0&ma=0`;


        this.modalIframeService.open('Carga de documentos',
            urlFirma,
            'Cerrar',
            'xl').then((closed) => {
                if (closed) {
                    this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                        this.lstDocumentos = resolve;
                    });
                }
            }).catch(() => console.error('Ocurrio un error con la modal de iframe'));
    }

    /**
     * Funcion para cargar los documentos cargados en la pantalla, se hace una consulta al servicio para obtener los documentos dependiendo del guid generado para la transaccion, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
     * @param uuid 
     * @returns Documents[]
     */
    public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {

        return new Promise((resolve) => {
            this.isLoadingFile = true;
            this._service.getDocumentosPantallaGuid(uuid)
                .subscribe((response: Documents[]) => {
                    if (response?.length > 0) {
                        this.isLoadingFile = false;

                        resolve(response);
                    }
                    else {
                        this.isLoadingFile = false;
                        resolve([]);
                    }
                }, (error: any) => {
                    this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                    this.isLoadingFile = false;
                    resolve([]);
                });

        });
    }

    /**
     * Funcion para eliminar un documento cargado en la pantalla, se muestra una modal de confirmacion antes de eliminar el documento, se hace una consulta al servicio para eliminar el documento dependiendo del id del documento, se muestra un mensaje de error si ocurre un error durante la eliminacion del documento o durante la consulta de los documentos despues de la eliminacion
     * @param Documento 
     */
    EliminarDocumentosPantalla(Documento: any): void {
        this.modalConfirmacionService.confirm('Confirmación',
            'Va eliminar el documento con nombre original ' + Documento.NombreOriginal + ', ¿desea continuar?',
            'Aceptar',
            'Cancelar',
            'sm').then((confirmed) => {
                if (confirmed) {
                    this._service.EliminarDocumentosPantalla(Documento.IdDocumento).subscribe({
                        next: (response: any) => {
                            if (response.succcess) {
                                this.alertService.success("Se eliminó correctamente el documento", { autoClose: true, keepAfterRouteChange: false });
                                this.GetDocumentosPantalla(this.uuid).then((resolve) => {
                                    this.lstDocumentos = resolve;
                                });
                            }
                        },
                        error: (error) => {
                            this.alertService.error(error.message, { autoClose: true, keepAfterRouteChange: false });
                            return;
                        }
                    });
                }
            }).catch(() => console.error('Ocurrio un error con la modal de confirmación'));

    }

    /**
     * Funcion para recargar la ruta actual, se utiliza para actualizar la informacion mostrada en pantalla despues de realizar alguna accion como crear, editar o eliminar una configuracion de dia inhábil sin necesidad de recargar toda la pagina, se muestra un mensaje de error si ocurre un error durante la recarga de la ruta
     */
    reloadCurrentRoute() {
        const currentUrl = this.router.url;
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
            this.router.navigate([currentUrl]);
        });
    }

    /**
     * Funcion para abrir la modal de visualizacion de documentos relacionados a la configuracion del dia inhábil, se hace una consulta al servicio para obtener los documentos dependiendo del id de la configuración, se muestra una modal con la lista de documentos cargados, se muestra un mensaje de error si ocurre un error durante la consulta de los documentos
     * @param idConfigDiasInhabiles 
     */
    abrirModal(idConfigDiasInhabiles: number): void {

        this.archivosModal = [];
        this.archivosModalError = '';
        this.archivosModalLoading = true;

        this.modalService.open(this.modalArchivosTpl, {
            size: 'xl',
            backdrop: 'static',
            keyboard: false,
        });

        this.Service
            .obtenerDocumentoRegistroDiaInhabil(idConfigDiasInhabiles)
            .subscribe({
                next: (archivos) => {
                    this.archivosModal = archivos ?? [];
                    this.archivosModalLoading = false;
                },
                error: () => {
                    this.archivosModalError =
                        'Ocurrio un error al cargar los archivos del registro de la configuracion de dia inhabil.';
                    this.archivosModalLoading = false;
                },
            });
    }



}